import { Icon } from '@bechtel/gds';
import { PickListButtonStyled } from './styled';

export const PickListButton = ({ onClick }) => {
  return (
    <PickListButtonStyled
      onClick={() => {
        onClick();
      }}
    >
      <Icon icon="ellipsis" iconStyle="solid" fillColor="primary.700" />
    </PickListButtonStyled>
  );
};
